<template lang="pug">
.service_card.d-flex.flex-column.flex-md-row
  .img_container
    .img_wrpper
      img.bg_default_gray.flex-grow-1(:src="item.Image")
    .text.d-flex.d-md-block.justify-content-between.align-items-center(
      @click="expand",
      :class="{ expand: isExpand }"
    )
      p {{ item.Title }}
      svg-icon.i_ml_2.d-md-none(
        iconClass="arrow_bottom_g",
        className="arrow_bottom_g"
      )
    div.title-note {{ item.TitleNote }}
    .see_more_btn.d-none.d-md-block.d-lg-none.i_mlr_0.text-center(
      v-if="item.IsDetail == 1",
      @click="openDialog"
    ) 詳細說明
    .see_more_btn.d-none.d-md-block.d-lg-none.i_mlr_0.text-center(
      v-if="$route.path === '/customerservice/damageprevention'"
    )
      a(:href="item.Url" target="_blank") 詳細說明

  .content.d-none.d-md-block.flex-grow-1
    p {{ item.Brief }}
      span {{ item.Content }}
    .see_more_btn.d-none.d-lg-block.i_mlr_0.text-right(
      @click="openDialog",
      v-if="item.IsDetail == 1"
    ) 詳細說明
    .see_more_btn.d-none.d-lg-block.i_mlr_0.text-right(
      v-if="$route.path === '/customerservice/damageprevention'"
    )
      a(:href="item.Url" target="_blank") 詳細說明
  .content.d-md-none.mobile.flex-grow-1(ref="content")
    p {{ item.Brief }}
      span {{ item.Content }}
    .btn_round.btn_blue_ci.d-md-none.i_mt_5(
      @click="openDialog",
      v-if="item.IsDetail == 1"
    ) 詳細說明
    .btn_round.btn_blue_ci.d-md-none.i_mt_5(
      v-if="$route.path === '/customerservice/damageprevention'"
    ) 
      a.text-white(:href="item.Url" target="_blank") 詳細說明
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "ServiceCard",
  props: {
    item: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    openDialog() {
      this.$emit("openDialog", this.item);
    },
    expand() {
      if (this.$store.state.screenWidth > 767) return;

      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.content.scrollHeight + 20;

        Velocity(
          this.$refs.content,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.content,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/good_service/service_card";
.title-note {
  font-size: 14px;
  text-align: center;
  color: $color_blue_btn_ci;
}

@media (max-width: 768px) {
  .title-note {
    text-align: left;
  }
}

.text-white{
  color: $color_white;
}
</style>
